import { Box } from "@chakra-ui/react";

type FillSwatch = {
  swatchType: "fill";
  color: string;

  borderColor?: string;
  borderWidth?: number;
  borderStyle?: "solid" | "dashed" | "dotted";
  fillOutlineColor?: string;
};

type LineSwatch = {
  swatchType: "line";
  color: string;
};

type CircleSwatch = {
  color: string;
  swatchType: "circle";

  borderColor?: string;
  borderWidth?: number;
  borderStyle?: "solid" | "dashed" | "dotted";
};

type SimpleSwatchProps = FillSwatch | LineSwatch | CircleSwatch;

// See README for what a simple swatch entails.
// In short, it is a simple representation of a single color, with optional border and fill outline.

export function SimpleSwatch(props: SimpleSwatchProps) {
  if (props.swatchType === "line") {
    const { color } = props;
    return <Box flexShrink={0} alignSelf="center" w="full" h={1} bg={color} borderRadius="full" />;
  }

  const borderWidth = props.borderWidth
    ? `${Math.min(Math.max(1, Math.round(props.borderWidth ?? 1)), 5)}px`
    : "base";

  const borderStyle = props.borderStyle ?? "solid";

  if (props.swatchType === "circle") {
    const { color, borderColor } = props;
    return (
      <Box
        flexShrink={0}
        w={3}
        h={3}
        bg={color}
        borderRadius="full"
        {...(borderColor ? { borderColor, borderWidth, borderStyle } : {})}
        boxSizing="border-box"
      />
    );
  }

  // fill
  if (props.swatchType === "fill") {
    const { color, borderColor, borderWidth, fillOutlineColor } = props;
    return (
      <Box
        flexShrink={0}
        w={4}
        h={4}
        bg={color}
        borderRadius="base"
        {...(borderColor ? { borderColor, borderWidth } : {})}
        boxSizing="border-box"
        style={{
          // fill-outline-color as inset shadow so it doesn't disturb layout
          boxShadow: fillOutlineColor ? `inset 0 0 0 1px ${fillOutlineColor}` : undefined,
        }}
      />
    );
  }

  throw new Error(`Unknown swatch type: ${JSON.stringify(props)}`);
}
